/*
 * A Token Variable, for display outside the Editor
 */

import React, { createRef, DragEvent } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { IconSize, Loop } from "../../icons";
import TruncatedText from "./TruncatedText";

enum TokenTheme {
  Light = "light",
  Dark = "dark",
}

interface TokenProps {
  name: string;
  type: "text" | "list";
  theme?: TokenTheme;
  isDraggable?: boolean;
  onDragStart?: (event: DragEvent) => void;
  onDragEnd?: (event: DragEvent) => void;
}

@observer
class Token extends React.Component<TokenProps> {
  public static defaultProps = {
    theme: TokenTheme.Light,
  };

  private dragLabelRef = createRef<HTMLDivElement>();

  public render(): JSX.Element {
    const { name, type, theme, isDraggable, onDragEnd } = this.props;
    const baseClass = `kl-token kl-token--${theme}`;
    const hasIcon = type === "list";
    const Icon = hasIcon && <Loop className="kl-token__icon" size={IconSize.Small} aria-label="List" />;

    return (
      <div
        className={classNames(baseClass, {
          "kl-token--draggable": isDraggable,
          "kl-token--has-icon": hasIcon,
        })}
        draggable={isDraggable}
        onDragStart={this.onDragStart}
        onDragEnd={onDragEnd}
      >
        {Icon}
        <TruncatedText className="kl-token__name">{name}</TruncatedText>
        <div
          className={classNames(baseClass, "kl-token--dragging kl-token__hidden-drag-label", {
            "kl-token--has-icon": hasIcon,
          })}
          ref={this.dragLabelRef}
          aria-hidden
        >
          {Icon}
          <div className="kl-token__name">{name}</div>
        </div>
      </div>
    );
  }

  private onDragStart = (event: DragEvent): void => {
    if (this.dragLabelRef.current) {
      event.dataTransfer.setDragImage(this.dragLabelRef.current, 15, 15);
    }

    if (this.props.onDragStart) {
      this.props.onDragStart(event);
    }
  };
}

export default Token;
export { TokenProps, TokenTheme };
